export enum UserRole {
    Admin      = 'admin',
    Viewer     = 'viewer',
    Instalater = 'instalater',
}

export enum HealthStatus {
    OK       = 'ok',
    Degraded = 'degraded',
    Error    = 'error',
    Unknown  = 'unknown',
    Stale    = 'stale',
}
